import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { Modal, ModalContent } from '@zocdoc-frontend-common/components-modal';
import { blue100 } from '@zocdoc-mezzanine/foundations-colors';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { Button } from '@zocdoc-frontend-common/components-button';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { EVENT_INITIATORS, INTERACTION_TYPES } from '@zocdoc/frontend-metrics';

export class GovernmentInsuranceModal extends Component {
    static propTypes = {
        locationId: PropTypes.string,
        onCancelClick: PropTypes.func,
        providerId: PropTypes.string,
        sendMetric: PropTypes.func,
        stateCode: PropTypes.string,
    };

    static defaultProps = {
        locationId: '',
        onCancelClick: noop,
        sendMetric: noop,
        stateCode: null,
    };

    componentDidMount() {
        const {
            locationId,
            providerId,
            sendMetric,
            stateCode: state,
        } = this.props;

        sendMetric({
            action: 'Show Wordpress Government Insurance Notice',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.VIEW,
            eventDetails: { state, locationId, providerId },
        });
    }

    render() {
        const { onCancelClick, stateCode } = this.props;

        if (!stateCode) {
            return null;
        }

        return (
            <StyledModal
                data-test="government-insurance-modal"
                ignoreClickOutside
                onClickCancel={onCancelClick}
            >
                <Wrapper>
                    <Message data-test="government-insurance-modal-copy">
                        {`Zocdoc is currently unable to support bookings for patients in ${stateCode} with the insurance plan you've selected.`}
                    </Message>
                    <FindOutMoreButton
                        data-test="government-insurance-modal-button"
                        href={`/about/accessforall/${stateCode.toLowerCase()}/`}
                        size="btn-med"
                        target="_blank"
                    >
                        Find out more
                    </FindOutMoreButton>
                </Wrapper>
            </StyledModal>
        );
    }
}

const StyledModal = styled(Modal)`
    ${ModalContent} {
        ${breakpoint.small} {
            padding-left: 25px;
            padding-right: 25px;
            padding-bottom: 30px;
        }
    }
`;

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Message = styled.div`
    color: ${blue100};
    font-family: ${FontFamily.SharpSansMedium};
    font-size: 15px;
    line-height: 22px;
    padding-bottom: 20px;
    width: 100%;
`;

const FindOutMoreButton = styled(Button)`
    font-family: ${FontFamily.SharpSansSemibold};
    font-size: 18px;

    ${breakpoint.small} {
        width: 240px;
    }
`;
